import styled from 'styled-components/macro';

import { colors } from '../../styles/vars';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  height: 60px;
  border-bottom: 1px solid ${colors['pale-grey']};

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: 71px;
    width: 1px;
    height: 60px;
    background: ${colors['pale-grey']};
  }
`;

export default Wrapper;
